// extracted by mini-css-extract-plugin
export default {"modal-shadow":"modal_modal-shadow__Uf6Su","blur_background":"modal_blur_background__ZLT9l"};